import { useEffect, useRef } from "react";
import { useSession } from "../lib/session";

declare global {
  interface Window {
    turnstile?: { render: (el: HTMLElement, opts: Record<string, unknown>) => string; remove: (id: string) => void };
  }
}

/** Cloudflare Turnstile widget — rendered only when the server has a site key configured and the visitor is anonymous. */
export function HumanCheck({ onToken }: { onToken: (t: string | null) => void }) {
  const { config, user } = useSession();
  const el = useRef<HTMLDivElement>(null);
  const siteKey = !user ? config?.turnstileSiteKey : null;

  useEffect(() => {
    if (!siteKey || !el.current) return;
    let id: string | null = null;
    const render = () => {
      if (window.turnstile && el.current) {
        id = window.turnstile.render(el.current, { sitekey: siteKey, callback: (t: string) => onToken(t), "expired-callback": () => onToken(null) });
      }
    };
    if (window.turnstile) render();
    else {
      const s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      s.async = true;
      s.onload = render;
      document.head.appendChild(s);
    }
    return () => {
      if (id && window.turnstile) window.turnstile.remove(id);
    };
  }, [siteKey, onToken]);

  if (!siteKey) return null;
  return <div ref={el} />;
}
